export default "__VITE_ASSET__CcqdmH2R__"